import OneNetworkConfig from '@/onenetwork/core/onenetwork.config'
import PrivateRouter from '@/onenetwork/layouts/PrivateRouter.vue'
import FlashOfferList from '@/modules/flashoffer/views/FlashOfferList.vue'
import FlashOfferDetail from '@/modules/flashoffer/views/FlashOfferDetail.vue'
import FlashOfferCreate from '@/modules/flashoffer/views/FlashOfferCreate.vue'
import FlashOfferResult from '@/modules/flashoffer/views/FlashOfferResult.vue'
const baseRoute = OneNetworkConfig.baseRoutePath
const flashOfferRouter = [
  {
    path: `${baseRoute}/flash-offer/list`,
    name: 'flash-offer-list',
    meta: {
      component: FlashOfferList
    },
    component: PrivateRouter,
  },
  {
    path: `${baseRoute}/flash-offer/detail/:id`,
    name: 'flash-offer-detail',
    meta: {
      component: FlashOfferDetail
    },
    component: PrivateRouter,
  },
  {
    path: `${baseRoute}/flash-offer/create`,
    name: 'flash-offer-create',
    meta: {
      component: FlashOfferCreate
    },
    component: PrivateRouter,
  },

  {
    path: `${baseRoute}/flash-offer/results`,
    name: 'flash-offer-result',
    meta: {
      component: FlashOfferResult
    },
    component: PrivateRouter,
  },
]
export default flashOfferRouter
